import { useCallback, useEffect, useState } from 'react';

import type { FormStepId } from 'shared/config/formStepId';
import { useAppDispatch } from 'shared/lib';

import type { TStepsValidateErrors } from 'widgets/AnketaWidget/lib/validateUserDataThunk';
import { validateUserDataThunk } from 'widgets/AnketaWidget/lib/validateUserDataThunk';

export const useValidateData = (
  callbacks: { onSuccess?: () => void; onError?: (stepsValidateErrors: TStepsValidateErrors) => void },
  enabled = true,
  stepsToValidate?: Array<ValuesOf<typeof FormStepId>>,
) => {
  const { onSuccess, onError } = callbacks;
  const [isValidating, setIsValidating] = useState(enabled);
  const dispatch = useAppDispatch();

  const validate = useCallback(() => {
    dispatch(validateUserDataThunk({ onComplete: () => setIsValidating(false), onSuccess, onError, stepsToValidate }));
  }, [dispatch, onSuccess, onError, stepsToValidate]);

  useEffect(() => {
    if (enabled) {
      setIsValidating(true);
      validate();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return isValidating;
};
